module.exports = __webpack_public_path__ + "img/AgeUpIcon4Active_ua.23dec824.webp";